<div class="rate-booking">
    <serviceos-ng-form [choices]="form.choices" (onAction)="onFormAction($event)" [errorMessage]="formErrorMessage"
        [showLoader]="showFormLoader" *ngIf="!tnxPage else success">
    </serviceos-ng-form>
    <ng-template #success>
        <div *ngIf="!showTip && completeScreen else tipScreen" class="success-view">
            <div>
                <ng-container *ngFor="let item of completeScreen">
                    <ng-container [ngSwitch]="item.id">
                        <div *ngSwitchCase="'title'">
                            <h3>
                                {{ item.properties.title }}
                            </h3>
                            <div class="rate">
                                <span *ngFor="let item of [1,2,3,4,5]" [ngClass]="{'fill': (item <= lastRateValue)}">
                                    <serviceos-ng-system-icon [icon]="'rating'">

                                    </serviceos-ng-system-icon>
                                </span>
                            </div>
                        </div>
                        <div *ngSwitchCase="'tip_pro'">
                            <div style="margin-bottom: 60px" *ngIf="lastRateValue >= 4 && tipProCondition">
                                <serviceos-ng-button
                                    (click)="showTipPro()"
                                    [isFullWidth]="true"
                                    [type]="'secondary'"
                                >
                                    {{ item.properties.title }}
                                </serviceos-ng-button>
                            </div>
                        </div>
                        <div *ngSwitchCase="'trust_pilot'">
                            <a class="share-exp-cta" class="invite" *ngIf="booking?.trustpilot_rate_url" [href]="booking.trustpilot_rate_url"
                                [target]="item.properties.target" class="share-exp-cta">
                                <img [src]="item.properties.url_image" alt=""> <span>{{item.properties.title}}</span>
                            </a>
                        </div>
                        <div *ngSwitchCase="'invite'">
                            <a class="share-exp-cta" [href]="item.properties.url" class="share-exp-cta"
                                [target]="item.properties.target">
                                <img [src]="item.properties.url_image" alt=""> <span>{{item.properties.title}}</span>
                            </a>
                        </div>
                        <div *ngSwitchCase="'member'">
                            <a class="share-exp-cta" [href]="item.properties.url" class="share-exp-cta"
                                [target]="item.properties.target">
                                <img [src]="item.properties.url_image" alt=""> <span>{{item.properties.title}}</span>
                            </a>
                        </div>
                        <div *ngSwitchCase="'done'">
                        </div>
                        <div *ngSwitchDefault>
                            <p class="share-exp-text" [innerHtml]="item.properties.title">
                            </p>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <ng-container *ngFor="let item of completeScreen">
                <ng-container [ngSwitch]="item.id">
                    <div *ngSwitchCase="'done'">
                        <serviceos-ng-button (click)="onDone()" [isFullWidth]="true">{{item.properties.title}}
                        </serviceos-ng-button>
                    </div>
                    <ng-container *ngSwitchDefault>

                    </ng-container>

                </ng-container>
            </ng-container>
        </div>
    </ng-template>
    <ng-template #tipScreen>
        <serviceos-web-tip-pro 
            *ngIf="completeScreen"
            [bookingId]="modalRef.configData.deep_link_object.fs_element_id"
            [position]="'rate'"
            (tipEvent)="onTipEvent($event)"
        ></serviceos-web-tip-pro>
    </ng-template>
    
</div>